import React from 'react';
import { StyledConfigurationContainer, StyledIndexContainerDiv } from '../../../Components/Styled';
import { Box, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import DataGridTable from '../../../Components/DataGrid';
import CreateEditRole from './CreateEditRole';
import { useSelector, useDispatch } from 'react-redux';
import BiztantuLoader from '../../../Components/Loader';
import { useEffect } from 'react';
import { requestGetAllPermission, requestGetAllRoles } from '../../../Store/Function/action';
import { useSnackbar } from 'notistack';
import { createOrderRequestData, updateOrderRequestData } from '../../../Utility/apiHelper';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { handleValidateCodevalue } from '../../../Utility/constant';
import { handleCreateEditConfiguration, requestHideLoader, requestShowLoader } from '../../../Store/Global/action';
import VisibilityIcon from '@mui/icons-material/Visibility';

const ConfigurationRole = ({}) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [formValues, setFormValues] = useState({})

    const [selectionData, setSelectionData] = useState({
        isCreate: false,
        isEdit: false,
        isEditRoleId: "",
        isDashboard: true,
    })
    const [datagriddata, setdatagriddata] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const dispatch = useDispatch();
    const isLoadingProgress = useSelector(state => state?.global.isLoading); 
    const [isEdit, setEdit] = useState(false);
    const allrolesData = useSelector(state => state?.permission?.allRoleTypes);
    const allpermissionset = useSelector(state => state?.permission?.allPermissionTypes);
    const [roleid, setRoleId] = useState("");
    const [selectionModel, setSelectionModel] = React.useState([]);

    useEffect(() => {
        
        if(selectionData?.isDashboard) {
            dispatch(requestGetAllRoles());
            dispatch(requestGetAllPermission());
        }
           
    },[selectionData?.isDashboard])

    useEffect(() => {
        const tableSpecificData = allrolesData.map(item => {
        return {
            id: item?.id,
            name: item?.name,
            // permission: item?.rolePermission.map(nesteditem => nesteditem?.permission?.name).join(" , "),
            description: item?.description
        }
        })
        
        setdatagriddata(tableSpecificData);
    },[allrolesData])

    const {enqueueSnackbar} = useSnackbar();

    const handleOnChange = (event) => {
        setFormValues({
            ...formValues,
            [event.target.name]: event.target.value
        })
    }

    const handleSearch = () => {

    }

    const handleResetSearch = () => {

    }

    const handleEditRole = () => {
        setSelectionData({
            isCreate: false,
            isEdit: true
        });
        dispatch(handleCreateEditConfiguration(true));
    }

    const handleCreateRole = () => {
        setSelectionData({
            ...selectionData,
            isCreate: true,
            isEdit: false,
            isDashboard: false,
        }) ;
        
          dispatch(handleCreateEditConfiguration(true));
    }

    const handleCustomBackbutton = () => {
        setSelectionData({
            ...selectionData,
            isCreate: false,
            isEdit: false,
            isDashboard: true,
        });

        dispatch(handleCreateEditConfiguration(false));
    }


    const handleEdit = (id) => {
        setSelectionData({
            ...selectionData,
            isEdit: true,
            isCreate: false,
            isEditRoleId: id,
            isDashboard: false
        });

          dispatch(handleCreateEditConfiguration(true));
    }

    const columns = [
        
        {
            field: 'actions',
            type: 'actions',
            headerName: <Tooltip title={handleValidateCodevalue(internationalise,'ROLE_SEARCH_VIEW_ROLE')} ><VisibilityIcon sx = {{marginTop : 3}} /></Tooltip>,
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
             
              return [
                <Tooltip title = {handleValidateCodevalue(internationalise,'ROLE_SEARCH_VIEW_ROLE')}>
                <GridActionsCellItem
                icon={<VisibilityIcon/>}
                  label={handleValidateCodevalue(internationalise,'ROLE_SEARCH_VIEW_ROLE')}
                  className="textPrimary"
                  disabled = {false}
                  onClick={() => handleEdit(id)}
                  color="inherit"
                />
                </Tooltip>
              ];
            },
        },
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_NAME'),
          flex: 1,
          editable: false ,
        },
        {
            field: 'description',
            headerName: handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_DESC'),
            flex: 1,
            editable: false,
        },
    ];
            const handleUpdateRoles = async(value,reqBody) => {
                dispatch(requestShowLoader())
                const url = `${process.env.REACT_APP_ORDER_URL}roles/${selectionData?.isEditRoleId}`;
                const responseData = await updateOrderRequestData(reqBody, url);
                if(responseData?.status == 200) {
                    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY") , {variant: "success"});
                    if(value){
                        handleCustomBackbutton()
                    }
                } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || 'COMMON_PLEASE_TRY_AGAIN') , {variant: "error"});
        }
                dispatch(requestHideLoader())
            }

    const handleSaveRoles = async(reqBody) => {
        dispatch(requestShowLoader())
        const url = `${process.env.REACT_APP_ORDER_URL}roles`;
        const rolepermissionurl = `${process.env.REACT_APP_ORDER_URL}rolepermissions`;
        const rolepermission = {};
        const responseData = await createOrderRequestData(reqBody, url);
        if(responseData?.status == 200) {
            if(reqBody?.ispermission.length > 0) {
                const permissionObj = reqBody?.ispermission?.[0];
                rolepermission["permission"] = {id: permissionObj?.id};
                rolepermission["role"] = {id: responseData?.data?.id};
                const response = await createOrderRequestData(rolepermission, rolepermissionurl);
                handleEdit(responseData?.data?.id)
            }
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), {variant: 'success'})
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.message || 'COMMON_PLEASE_TRY_AGAIN') , {variant: "error"});
        }
        dispatch(requestHideLoader())
    }

    return (

        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
        
        {(!selectionData?.isCreate && !selectionData?.isEdit) ? <Box sx={{marginBottom: 0, backgroundColor: "white"
                // '& .MuiTextField-root': { m: 1, width: '35ch', marginTop: 3 },
                }}>

            <StyledConfigurationContainer>
                <Typography variant='h6'>
                    {handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_TITLE')}
                </Typography>
            
                {/* <Button startIcon={<img src={createicon} style={{height: "15px"}} />} className='biztantu-sec-btn'  onClick={handleCreateRole}>{handleValidateCodevalue(internationalise,'CONF_CREATE_ROLE')}</Button>
            */}
            </StyledConfigurationContainer>
                
            
            {/* <StyledLeadContainer className='mt-50'>
                <Typography variant='h6'>
                    {handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_TITLE')}
                </Typography>
            <StyledConfigurationContainer sx = {{width: '50%'}}>
                <Box>
                </Box>
                <Button startIcon={<img src={createicon} style={{height: "15px"}} />} className='biztantu-sec-btn'  onClick={handleCreateRole}>{handleValidateCodevalue(internationalise,'CONF_CREATE_ROLE')}</Button>
            </StyledConfigurationContainer>
            </StyledLeadContainer> */}
                {/* <StyledLeadContainer>
                    <TextFiledWithLabel
                        name={roleSearchName?.applicationName}
                        value= {formValues?.[roleSearchName?.applicationName]}
                        label={handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_NAME')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                        name={roleSearchName?.applicationCode}
                        value= {formValues?.[roleSearchName?.applicationCode]}
                        label={handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_CODE')}
                        handleOnChange={handleOnChange}
                    />
                    <SelectBoxWithLabel
                        name={roleSearchName?.applicationStatus}
                        value= {formValues?.[roleSearchName?.applicationStatus]}
                        label={handleValidateCodevalue(internationalise,'CONF_ROLE_SEARCH_STATUS')}
                        optionMenuItem={applicationStatusmenu}
                        handleOnChange={handleOnChange}
                    />
                </StyledLeadContainer>
                <SearchModuleButton
                    handleSearch = {handleSearch}
                    handleResetSearch={handleResetSearch}
                    searchBtnName= {handleValidateCodevalue(internationalise,'COMMON_SEARCH')}
                    resetBtnName={handleValidateCodevalue(internationalise,'COMMON_RESET')}
                /> */}
                
           <StyledIndexContainerDiv>
                <DataGridTable
                    isCheckboxReq={false}
                    dataGridData={datagriddata}
                    isLoading={false}
                    height={"calc(100vh - 221px)"}
                    marginTop='0px'
                    selectionModel={selectionModel}
                    setSelectionModel={(data) => setSelectionModel(data)}
                    columns={columns}
                    rowModesModel={rowModesModel}
                    // handleUpdateProduct={handleUpdateProduct}
                />
            </StyledIndexContainerDiv>
            </Box>  :
            <CreateEditRole
                isViewMode = {true}
                handleUpdateRoles = {handleUpdateRoles}
                selectionData = {selectionData}
                handleSavePermission = {handleSaveRoles}
                handleCustomBackbutton = {handleCustomBackbutton}
                isEdit = {selectionData?.isEdit}
                isCreate = {selectionData?.isCreate}
                enqueueSnackbar = {enqueueSnackbar}
            />}
        </BiztantuLoader>
    )
}

export default ConfigurationRole;